import { render, staticRenderFns } from "./AbnormalRecord.vue?vue&type=template&id=562e9be1&scoped=true"
import script from "./AbnormalRecord.vue?vue&type=script&lang=js"
export * from "./AbnormalRecord.vue?vue&type=script&lang=js"
import style0 from "./AbnormalRecord.vue?vue&type=style&index=0&id=562e9be1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562e9be1",
  null
  
)

export default component.exports